import React, { ComponentPropsWithRef, ElementType } from 'react'
import { ReactComponent as Spinner } from './../../resources/svg/spinner.svg'
import { Overlay } from './Loading.styles'

type Props = ComponentPropsWithRef<ElementType> & {
  text: string
  isLoading: boolean
}

const Loading: React.FC<Props> = ({ text, isLoading, className, ...props }: Props) => {
  return (
    <Overlay className={(className ?? '') + (isLoading ? ' is-loading' : '')} {...props}>
      <div className="overlay-container">
        <div className="spinner">
          <Spinner />
        </div>

        {text?.length > 0 && (
          <div className="text">{text}</div>
        )}
      </div>
    </Overlay>
  )
}

export default Loading
